
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invite",
      function () {
        return require("private-next-pages/invite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invite"])
      });
    }
  